import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ToastMessageModel} from '../models/toast-message-model';
import {ToastTypeEnum} from '../enums/toast-type';

@Injectable({providedIn: 'root'})
export class ToastService {
    private toastSubject = new BehaviorSubject<ToastMessageModel | null>(null);
    private queue: ToastMessageModel[] = [];
    private currentToast: ToastMessageModel = null;
    private currentToastTimeout: any; // Reference to the current toast timeout

    toast$ = this.toastSubject.asObservable();

    private displayNextToast(): void {
        if (this.currentToast && this.queue.length === 0) {
            this.currentToast = null;
            // this.toastSubject.next( this.currentToast);

            setTimeout(() => {
                this.toastSubject.next(this.currentToast);
            }, 150); // what to fully finish fade-out animation (300ms/2)
            return;
        }


        this.currentToast = this.queue.shift();
        if (this.currentToast) {
            this.toastSubject.next(this.currentToast);
        }


        // Set timeout for automatic closing
        this.currentToastTimeout = setTimeout(() => this.closeToast(), this.currentToast?.delay || 30000);
    }

    showToast(type: ToastTypeEnum, message: string, delay = 30000, className?: string): void {
        console.log('showToast push', message);

        if (!Object.values(ToastTypeEnum).includes(type) || !message) {
            console.warn('Invalid toast type or message');
            return;
        }

        this.queue.push({type, message, delay, className});

        if (!this.currentToast) {
            this.displayNextToast();
        }
    }

    showSuccess(message: string, delay = 30000): void {
        this.showToast(ToastTypeEnum.SUCCESS, message, delay);
    }

    showSuccessWide(message: string, delay = 30000): void {
        this.showToast(ToastTypeEnum.SUCCESS, message, delay, 'toast-wide');
    }

    showError(message: string, delay = 30000): void {
        this.showToast(ToastTypeEnum.ERROR, message, delay);
    }

    showErrorWide(message: string, delay = 30000): void {
        this.showToast(ToastTypeEnum.ERROR, message, delay, 'toast-wide');
    }

    showInfo(message: string, delay = 30000): void {
        this.showToast(ToastTypeEnum.INFO, message, delay);
    }

    showInfoWide(message: string, delay = 30000): void {
        this.showToast(ToastTypeEnum.INFO, message, delay, 'toast-wide');
    }

    showWarning(message: string, delay = 30000): void {
        this.showToast(ToastTypeEnum.WARNING, message, delay);
    }

    showWarningWide(message: string, delay = 30000): void {
        this.showToast(ToastTypeEnum.WARNING, message, delay, 'toast-wide');
    }

    closeToast(): void {
        if (this.currentToastTimeout) {
            clearTimeout(this.currentToastTimeout); // Clear the timeout
            this.currentToastTimeout = null;
        }
        this.displayNextToast(); // Display the next toast in the queue or hide if none left
    }
}
